<template>
    <div class="transport-page">
      <div class="container mt-5">
        <!-- Navigation Tabs -->
        <div class="head-tabs">
          <div 
            v-for="(tab, index) in tabs" 
            :key="index"
            :class="['tab-item', { active: activeTab === index }]"
            @click="activeTab = index"
          >
            {{ tab }}
          </div>
        </div>
  
        <div class="w-100 text-light p-2" style="background-color:#002d62;">
          Get instan quoate for your flight forwarding service
        </div>
  
        <!-- Icon Section -->
        <div class="icon-section track-trace text-center mb-5">
          <div v-for="service in services" :key="service.id" class="icon-box">
            <div class="icon">
              <i :class="service.icon"></i>
            </div>
            <p>{{ service.name }}</p>
          </div>
        </div>
  
        <!-- Track and Trace Form -->
        <div class="track-trace p-4 mb-5">
          <h4>Track and Trace</h4>
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-4 mb-3">
                <label for="vesselName" class="form-label">Vessel Name</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="vesselName" 
                  v-model="formData.vesselName" 
                  required
                >
              </div>
              <div class="col-4 mb-3">
                <label for="scheduleDate" class="form-label">Schedule Date</label>
                <input 
                  type="date" 
                  class="form-control" 
                  id="scheduleDate" 
                  v-model="formData.scheduleDate" 
                  required
                >
              </div>
              <div class="col-4 mb-3">
                <label for="dischargePort" class="form-label">Discharge Port</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="dischargePort" 
                  v-model="formData.dischargePort"
                >
              </div>
              <div class="col-4 mb-3">
                <label for="referenceNo" class="form-label">Reference No</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="referenceNo" 
                  v-model="formData.referenceNo"
                >
              </div>
              <div class="col-4 mb-3">
                <label for="transportMode" class="form-label">Mode of Transport</label>
                <select 
                  id="transportMode" 
                  class="form-select" 
                  v-model="formData.transportMode" 
                  required
                >
                  <option value="" disabled>Choose</option>
                  <option value="sea">Sea</option>
                  <option value="air">Air</option>
                </select>
              </div>
            </div>
            <button type="submit" class="btn btn-success">Search</button>
            <button type="reset" class="btn btn-danger" @click="resetForm">Clear</button>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TransportPage',
    data() {
      return {
        activeTab: 0,
        tabs: [
          'Transport',
          'Supply Chain Solutions',
          'Law and Regulation'
        ],
        services: [
          { id: 1, name: 'Sea Freight', icon: 'fas fa-ship' },
          { id: 2, name: 'Air Freight', icon: 'fas fa-plane' },
          { id: 3, name: 'Customs Brokerage', icon: 'fas fa-cart-arrow-down' },
          { id: 4, name: 'Door-to-Door Service', icon: 'fas fa-truck' },
          { id: 5, name: 'Warehouse Management', icon: 'fas fa-warehouse' }
        ],
        formData: {
          vesselName: '',
          scheduleDate: '',
          dischargePort: '',
          referenceNo: '',
          transportMode: ''
        }
      }
    },
    methods: {
      handleSubmit() {
        // จัดการการส่งฟอร์ม
        console.log('Form submitted:', this.formData)
      },
      resetForm() {
        this.formData = {
          vesselName: '',
          scheduleDate: '',
          dischargePort: '',
          referenceNo: '',
          transportMode: ''
        }
      }
    }
  }
  </script>
  
  <style scoped>
  body {
    background-image: url('@/assets/bg-transport.png');
    background-size: cover;
    background-position: center;
  }
  
  .head-tabs {
    border-bottom: none;
    width: 100%;
    display: flex;
  }
  
  .tab-item {
    font-weight: bold;
    background-color: #fff;
    color: #002d62;
    text-align: center;
    padding: 10px 0;
    width: 33.33%;
    margin-right: 0;
    border-radius: 0;
    cursor: pointer;
  }
  
  .head-tabs .tab-item.active {
    background-color: #002d62;
    color: #fff;
    border-radius: 0;
    border-bottom: 3px solid #002d62;
  }
  
  .track-trace {
    background-color: rgba(255, 255, 255, 0.6);
    padding: 20px;
    border-radius: 5px;
  }
  
  .track-trace label {
    font-weight: bold;
  }
  
  .track-trace .btn {
    margin-top: 10px;
  }
  
  .icon {
    font-size: 40px;
    color: #002d62;
  }
  
  .icon-section {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
  }
  
  .icon-section .icon-box {
    text-align: center;
    flex: 1;
  }
  </style>